import { Box, Stack, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import DangerousIcon from '@mui/icons-material/Dangerous';
import moment from 'moment';
import usePlanStore from '../../../../../../../../../store/planStore';

export default function InfoBox() {
  const { countryForms, selectedCountry } = usePlanStore();
  const tvConfig = countryForms[selectedCountry!]?.offline?.tv;
  const daysInWeek = 7;

  const minCampaignDays = (tvConfig?.minCampaignLength ?? 0) * daysInWeek;
  const maxCampaignDays = (tvConfig?.maxCampaignLength ?? 0) * daysInWeek;
  const recommendedCampaignDays =
    (tvConfig?.recommendedCampaignLength ?? 0) * daysInWeek;

  const startDate = moment(tvConfig?.startDate, 'DD-MM-YYYY');
  const endDate = moment(tvConfig?.endDate, 'DD-MM-YYYY');

  const difference = Number.isNaN(endDate.diff(startDate, 'days'))
    ? 0
    : endDate.diff(startDate, 'days') + 1;

  const isOutsideOfRange =
    difference < minCampaignDays || difference > maxCampaignDays;

  return (
    <Box
      sx={{
        background: '#e6e7ea',
        borderRadius: '5px',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        height: '29px',
        px: '44px',
        width: '100%',
      }}
    >
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        alignItems="center"
      >
        <Stack justifyContent="center">
          <Typography variant="body2" fontSize="10px" textAlign="center">
            Allowed campaign length:
          </Typography>
          <Typography variant="body2" fontWeight={700} textAlign="center">
            {tvConfig?.minCampaignLength} - {tvConfig?.maxCampaignLength} weeks
            ({minCampaignDays} - {maxCampaignDays} days)
          </Typography>
        </Stack>
        <Stack justifyContent="center">
          <Typography variant="body2" fontSize="10px" textAlign="center">
            Selected campaign length:
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            textAlign="center"
            color={isOutsideOfRange ? 'warning.main' : 'success.dark'}
          >
            {difference} days{' '}
            {difference === recommendedCampaignDays && (
              <Typography
                color={isOutsideOfRange ? 'warning.main' : 'success.dark'}
                component="span"
                fontSize="12px"
                fontWeight={700}
              >
                (recommended)
              </Typography>
            )}
          </Typography>
        </Stack>
        <Stack flexDirection="row" alignItems="center">
          <Stack justifyContent="center" pr={4}>
            <Typography variant="body2" fontSize="10px" textAlign="center">
              Status:
            </Typography>
            <Typography
              variant="body2"
              fontWeight={700}
              textAlign="center"
              textTransform="uppercase"
              color={isOutsideOfRange ? 'warning.main' : 'success.dark'}
            >
              {isOutsideOfRange ? 'Out Of Range' : 'Within range'}
            </Typography>
          </Stack>
          {isOutsideOfRange ? (
            <DangerousIcon
              sx={{
                color: 'warning.main',
              }}
            />
          ) : (
            <DoneIcon
              sx={{
                color: 'success.dark',
              }}
            />
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
